import { render, staticRenderFns } from "./LandingListaNascita.vue?vue&type=template&id=945695c8"
import script from "./LandingListaNascita.vue?vue&type=script&lang=js"
export * from "./LandingListaNascita.vue?vue&type=script&lang=js"
import style0 from "./LandingListaNascita.vue?vue&type=style&index=0&id=945695c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports